import styled, { css, keyframes } from 'styled-components/macro';
import { Text } from 'components/ui/text';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding-right: ${theme.spacings.xs};
    position: absolute;
    z-index: 1000;
    min-width: 280px;
    background: ${theme.semantic.bg.surface};
    border: 1px solid ${theme.semantic.border.surface};
    border-radius: ${theme.radiuses.xs};
    overflow: hidden;
    box-sizing: border-box;
    animation: ${fadeIn};
    animation-duration: ${theme.tokens.animation.duration.short};
    animation-timing-function: ease-in-out;
    pointer-events: auto;
  `}
`;

export const NoOptionsMessage = styled(Text).attrs({
  color: 'gray.400',
  align: 'center',
})`
  ${({ theme }) => css`
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
  `}
`;
